export default "__VITE_PUBLIC_ASSET__839fdd2b__"